import { GetStaticProps } from 'next';

import Index from '@/landing/e-commerce/new-home';

export default Index;

/** SSG 静态生成 - 优化 TTFB */
export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
    revalidate: 3600, // ISR: 每小时重新生成
  };
};
